<template>
  <div class="dram-roll">
    <label v-for="(item, i) in items" :key="i" :class="{ disabled: disabled && i }">
      <div v-if="i" class="separator" />
      <input
        v-bind="$attrs"
        type="radio"
        :value="item"
        :checked="item === value"
        v-on="changeListeners"
        :disabled="disabled && i ? true : false"
      />
      <span class="item" :class="{ checked: item === value }">
        {{ item }}
      </span>
    </label>
  </div>
</template>

<script>
import scrollIntoView from '@/utils/scrollIntoView'
/**
 * ドラムロール選択
 */
export default {
  name: 'DrumRoll',
  components: {},
  model: {
    value: 'value',
    event: 'change',
  },
  props: {
    /** 選択肢 */
    items: { type: Array, required: true },
    /** 値 (v-model) */
    value: { type: [String, Number] },
    /** 00以外を非活性 */
    disabled: Boolean,
  },
  computed: {
    changeListeners() {
      return {
        ...this.$listeners,
        change: e => {
          /**
           * 値の変更 (v-model)
           * @event change
           * @type {string|number}
           */
          this.$emit('change', e.target.value)
        },
      }
    },
  },
  watch: {
    value(value) {
      if (value) this.scrollIntoView({ behavior: 'smooth' })
    },
  },
  mounted() {
    this.scrollIntoView()
  },
  methods: {
    /**
     * 選択中位置へスクロール
     * @param {object} options [scrollIntoView](https://developer.mozilla.org/ja/docs/Web/API/Element/scrollIntoView#%E3%83%91%E3%83%A9%E3%83%A1%E3%83%BC%E3%82%BF) のオプション
     * @public
     */
    async scrollIntoView(options) {
      await this.$nextTick()
      scrollIntoView(this.$el.querySelector(':checked + .item'), {
        behavior: 'auto',
        block: 'center',
        inline: 'center',
        ...options,
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.dram-roll {
  border: 1px solid var(--border-color);
  border-radius: 4px;
  height: fit-content;
  max-height: 360px;
  min-width: 120px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  width: fit-content;

  input {
    display: none;
  }
}

.item {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 32px;
  font-weight: 600;
  height: 64px;
  justify-content: center;

  &.checked {
    background: var(--very-light-yellow);
  }
}

label {
  position: relative;

  & + label {
    .item::before {
      border-top: var(--light-gray) 1px solid;
      content: '';
      display: block;
      position: absolute;
      top: 0;
      width: 48px;
    }
  }

  &.disabled {
    .item {
      background: var(--very-light-gray);
    }
  }
}
</style>
